import $ from 'jquery';
import Cache from 'root/cache';
import Modals from 'root/modals';
import SVG from 'root/module/svg_icon';
import View from 'view/base';

export default View.extend({
    className: 'feedback-integrations',

    events: {
        'click .integration-send' : 'onSendToIntegration'
    },

    dom_handlers: {
        onSendToIntegration: function(e) {
            var integration_type = $(e.currentTarget).data('val');
            Modals.sendToIntegration(integration_type, this.model);
        }
    },

    initialize: function(options) {
        this.show_empty = !!options.show_empty;

        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var integrations = [
            {
                model: Cache.integration_jira.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'jira_url',
                name: 'Jira',
                logo: '/image/jira_small.png'
            },
            {
                model: Cache.integration_clickup.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'clickup_url',
                name: 'ClickUp',
                logo: '/image/clickup_small.png'
            },
            {
                model: Cache.integration_wrike.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'wrike_url',
                name: 'Wrike',
                logo: '/image/wrike_small.png'
            },
            {
                model: Cache.integration_azure_devops.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'azure_devops_url',
                name: 'Azure DevOps',
                logo: '/image/azure_devops_small.png'
            },
            {
                model: Cache.integration_teamwork.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'teamwork_url',
                name: 'Teamwork',
                logo: '/image/teamwork_small.png'
            },
            {
                model: Cache.integration_trello.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'trello_url',
                name: 'Trello',
                logo: '/image/trello_small.png'
            },
            {
                model: Cache.integration_basecamp.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'basecamp_url',
                name: 'Basecamp',
                logo: '/image/basecamp_small.png'
            },
            {
                model: Cache.integration_asana.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'asana_url',
                name: 'Asana',
                logo: '/image/asana_small.png'
            },
            {
                model: Cache.integration_monday.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'monday_url',
                name: 'Monday',
                logo: '/image/monday_small.png'
            },
            {
                model: Cache.integration_zendesk.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'zendesk_url',
                name: 'zendesk',
                logo: '/image/zendesk_small.png'
            },
            {
                model: Cache.integration_github.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'github_url',
                name: 'GitHub',
                logo: '/image/github_small.png'
            },
            {
                model: Cache.integration_gitlab.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'gitlab_url',
                name: 'GitLab',
                logo: '/image/gitlab_small.png'
            },
            {
                model: Cache.integration_linear.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'linear_url',
                name: 'Linear',
                logo: '/image/linear_small.png'
            },
            {
                model: Cache.integration_notion.findWhere({project_id: this.model.get('project_id')}),
                url_property: 'notion_url',
                name: 'Notion',
                logo: '/image/notion_small.png'
            },
        ];

        var integrations_connected = integrations.filter((option) => option.model && option.model.isConnected());

        var content = '';

        integrations_connected.forEach((option) => {
            var tooltip = '';
            var is_processing = this.model.get(option.url_property) === 'processing';

            if (this.model.get(option.url_property)) {
                tooltip = is_processing ? 'Sending to ' + option.name : 'View in ' + option.name;
            } else {
                tooltip = 'Send to ' + option.name;
            }

            if (integrations_connected.length > 1) {
                content +=
                '<button class="integration-send integration-send-small tertiary tooltip small"' + (is_processing ? ' disabled' : '') + ' data-val="' + option.name.replace(' ', '_').toLowerCase() + '" data-title="' + tooltip  + '">' +
                    '<img class="integration-icon" src="' + option.logo + '">' +
                    (this.model.get(option.url_property) && this.model.get(option.url_property) !=='processing' ?
                    '<div class="status-sent">' + SVG.tick + '</div>' : '') +
                '</button>';
            } else {
                content +=
                '<button class="integration-send tertiary small"' + (is_processing ? ' disabled' : '') + ' data-val="' + option.name.replace(' ', '_').toLowerCase() + '">' +
                    '<img class="integration-icon" src="' + option.logo + '">' +
                    '<span>' + tooltip + '</span>' +
                '</button>';
            }
        });

        if (integrations_connected.length === 0 && this.show_empty) {
            content = '<div class="text-info italic">No integrations connected</div>';
        }

        this.$el.html(content);

        return this;
    }
});